/*
 * @Description: 
 * @Author: zcy
 * @Date: 2022-01-10 15:20:58
 * @LastEditors: lishiqiao
 * @LastEditTime: 2022-07-05 09:38:17
 */
import http from "@/axios/index";
/**接口根路经标识 */

export function initPageList(data) {
  const url = `/mdtIndicatorsOrg/searchMdtIndicatorsOrgList`
  return http.post(url, data)
}

// 获取所有机构--指标概览
export function getAllJiGou(rootId) {
  const url = `/desktopReport/queryIndexOrgFish/${rootId}`
  return http.get(url)
}

/**
 * @Author: lishiqiao
 * @Date: 2022-07-05 09:37:28
 * @description: 获取养殖品种下拉列表
 * @param {*} rootId
 */
export function getBreedList(rootId) {
  const url = `/desktopReport/queryIndicatorsBreed/fish/${rootId}`
  return http.get(url)
}

// 获取所有批次--指标概览
export function getAllPiCi(rootId) {
  const url = `/desktopReport/queryIndexPerioyFish/${rootId}`
  return http.get(url)
}